import React, { useRef, useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';
// Removed Link import since we're using <a> instead

const PdfViewer = ({ documentUrl }) => {
  const [hasError, setHasError] = useState(false);
  const embedRef = useRef(null);

  useEffect(() => {
    const embed = embedRef.current;
    if (embed) {
      const handleError = () => setHasError(true);
      embed.addEventListener('error', handleError);
      return () => embed.removeEventListener('error', handleError);
    }
  }, []);

  return (
    <div style={{ height: '100vh' }}>
      <a
        className="my-1"
        style={{ display: 'flow-root' }}
        href={documentUrl}
        download
        target="_blank"
        rel="noopener noreferrer"
      >
        <Trans ns="commerce">PDF download</Trans>
      </a>
      {hasError ? (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <p>
            <Trans ns="commerce">
              Unable to load PDF. Please try downloading instead.
            </Trans>
          </p>
        </div>
      ) : (
        <embed
          ref={embedRef}
          src={documentUrl}
          type="application/pdf"
          width="100%"
          height="100%"
        />
      )}
    </div>
  );
};

PdfViewer.propTypes = {
  documentUrl: PropTypes.string.isRequired
};

export default PdfViewer;
